import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { t as tFn } from "@/lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("ijff_lang") : null;
    return saved || "en";
  });

  useEffect(() => {
    localStorage.setItem("ijff_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => tFn(key, lang), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be inside LanguageProvider");
  return ctx;
};
